/**
 * Action types for redis nodes functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of redis nodes.
 */

// Get redis nodes constants
export const REDIS_NODES_REQUEST_GET = 'REDIS_NODES_REQUEST_GET';
export const REDIS_NODES_RESPONSE_GET_SUCCESS = 'REDIS_NODES_RESPONSE_GET_SUCCESS';
export const REDIS_NODES_RESPONSE_GET_FAIL = 'REDIS_NODES_RESPONSE_GET_FAIL'
